// Shared by every Explore view that embeds <media ref="media"> with a
// "media" v-tab: makes sure an unsaved gallery reorder doesn't get
// silently dropped when the user switches tabs or navigates away.
//
// Usage in the host component:
//   - give <media> a `ref="media"`
//   - call `await this.confirmLeaveMediaGalleryIfDirty()` at the top of
//     beforeRouteLeave, before its own next()
//   - add a `tab` watcher: `tab(newVal, oldVal) { this.guardMediaTabSwitch(newVal, oldVal, '<media tab value>') }`
export const MediaGalleryLeaveGuardMixin = {
  methods: {
    async confirmLeaveMediaGalleryIfDirty() {
      let mediaRef = this.$refs.media
      if (mediaRef && mediaRef.poiGalleryDirty) {
        await mediaRef.promptSaveDiscardIfDirty()
      }
    },
    // mediaTabValue is whatever this component's own tab data holds while
    // on the Media tab — a string ('media') for href-based v-tabs, or a
    // number (the tab's index) for plain unnamed ones.
    guardMediaTabSwitch(newVal, oldVal, mediaTabValue) {
      if (oldVal !== mediaTabValue || newVal === mediaTabValue) {
        return
      }
      let mediaRef = this.$refs.media
      if (!mediaRef || !mediaRef.poiGalleryDirty) {
        return
      }
      // Snap the tab back immediately so the switch doesn't visibly happen
      // before the user has actually decided anything, then apply the
      // originally-requested tab once they have.
      this.tab = mediaTabValue
      mediaRef.promptSaveDiscardIfDirty().then(() => {
        this.tab = newVal
      })
    }
  }
}
